/** Route param holding a guide's slug (shared by My Space and Workspace routes). */
export const GUIDE_SLUG_PARAM = "guideSlug";

/** Guides logo (3D book + bulb), used by the sidebar item and top-bar button. */
export const GUIDES_ICON = "/icons/interface-icons/shared/icon-3d-guides.png";
